import PartnerBrand, {IPartnerBrandPaymentsStatus, PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import Account from "../../../model/account/Account";
import QuoteEmailStyle from "../../../model/partnerBrand/QuoteEmailStyle";

/**
 * Fetch partner brands successful action.
 */
export const PARTNER_BRANDS_FETCHED = "PARTNER_BRANDS_FETCHED";
export type PARTNER_BRANDS_FETCHED = { partnerBrands: PartnerBrandSearch[] }

/**
 * Create partner brand successful action.
 */
export const PARTNER_BRAND_CREATED = "PARTNER_BRAND_CREATED";
export type PARTNER_BRAND_CREATED = { partnerBrand: PartnerBrand }

/**
 * Update partner brand successful action.
 */
export const PARTNER_BRAND_UPDATED = "PARTNER_BRAND_UPDATED";
export type PARTNER_BRAND_UPDATED = { partnerBrand: PartnerBrand }

/**
 * Fetch partner brand accounts successful action.
 */
export const PARTNER_BRAND_ACCOUNTS_FETCHED = "PARTNER_BRAND_ACCOUNTS_FETCHED";
export type PARTNER_BRAND_ACCOUNTS_FETCHED = { accounts: Account[], partnerBrandId: string }

/**
 * Fetch quote email templates styles successful action.
 */
export const QUOTE_EMAIL_STYLES_FETCHED = "QUOTE_EMAIL_STYLES_FETCHED";
export type QUOTE_EMAIL_STYLES_FETCHED = { quoteEmailStyles: QuoteEmailStyle[] }

/**
 * Fetch partner brand payments status successful action.
 */
export const PARTNER_BRAND_PAYMENTS_STATUS_FETCHED = "PARTNER_BRAND_PAYMENTS_STATUS_FETCHED";
export type PARTNER_BRAND_PAYMENTS_STATUS_FETCHED = { paymentStatus: IPartnerBrandPaymentsStatus, partnerBrandId: string }

/**
 * Fetch partner brand successful action.
 */
export const PARTNER_BRAND_FETCHED = "PARTNER_BRAND_FETCHED";
export type PARTNER_BRAND_FETCHED = { partnerBrand: PartnerBrand }